import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';

SwiperCore.use( [ Navigation ] );

const swiperInitialValues = {
  segment: { value: 'couple', slideIndex: 1 },
  firmness: { value: 'soft-supportive', slideIndex: 2 },
  pose: { value: 'side', slideIndex: 2 },
};

export default {
  firstSlide: 0,
  data: {
    segment: swiperInitialValues.segment.value,
    firmness: swiperInitialValues.firmness.value,
    pose: swiperInitialValues.pose.value,
    age: '',
    weight: '',
    space: '',
    allergy: '',
    aches: '',
    temperature: '',
    budget: '',
    sporting: '',
  },
  results: {},

  $body: $( 'body' ),
  $wrapper: $( '.m-selector-wrapper' ),
  $mattressContainer: $( '.select-mattress' ),
  $mattressTrigger: $( '.mattress-trigger' ),
  $ajaxForm: $( '.ajax-mattress-form' ),
  $preloader: $( '.preloader' ),
  $resultsInner: $( '.m-selector__screen--results-inner' ),
  $nextSlide: $( '.next-slide' ),
  $prevSlide: $( '.prev-slide' ),
  $circleSliderProgress: $( '.m-selector__progress' ),

  init() {
    const self = this;

    if ( self.$wrapper.length ) {
      self.loadScreens();

      if ( self.$mattressTrigger.length ) {
        self.$mattressTrigger.on( 'click', self.loadScreens.bind( this ) );
      }

      self.$ajaxForm.submit( function ( e ) {
        e.preventDefault();
      } );

      $( document ).keyup( function ( e ) {
        // esc key
        if ( e.keyCode === 27 ) {
          self.closeSelector();
        }
      } );

      self.$body.on( 'click', '.next-slide', function ( e ) {
        if ( e ) {
          e.preventDefault();
        }

        const screenIndex = $( this ).attr( 'data-next-slide' );

        self.updateProgress( screenIndex );
        self.toggleScreen( screenIndex );

        if ( $( this ).hasClass( 'next-slide--get-result' ) ) {
          self.getResult();
          self.$circleSliderProgress.fadeOut();
        } else {
          self.$circleSliderProgress.fadeIn();
        }
      } );

      self.$body.on( 'click', '.m-selector__close', self.closeSelector.bind( this ) );

      $( '#email-result-modal' ).on( 'show.bs.modal', function ( e ) {
        $( '.gform_hidden #input_5_3' ).val( JSON.stringify( self.data ) );
        $( '.gform_hidden #input_5_6' ).val( JSON.stringify( self.results ) );
      } );
    }
  },

  getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  },

  setCookie(name, value) {
    document.cookie = name + "=" + value + ";path=/";
  },


  generateUID() {
    return self.crypto.randomUUID();
  },

  getResult() {
    const self = this;
    var msUID = self.getCookie('msUID');
    if (!msUID) {
      // Use the crypto API to generate a UUID
      msUID = window.crypto.randomUUID();
      self.setCookie('msUID', msUID);
    }


    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push( {
      event: 'mattressSelect.results',
      data: self.data,
    } );

    $.ajax( {
      type: 'POST',
      url: Sealy.ajaxUrl,
      dataType: 'json',
      data: {
        action: 'get_mattress_selector_result',
        data: self.data,
        branding: Sealy.mattressSelectorBranding,
        msUID: msUID,
      },
      beforeSend: function () {
        self.$resultsInner.html( '<i class="fa fa-refresh fa-spin fa-3x fa-fw color-white"></i>' );
      },
      success: function ( response ) {
        if ( response.success ) {
          self.$resultsInner.html( response.data.html );
          self.results = response.data.results;
        }
      },
    } );
  },


  updateProgress( screenIndex ) {
    const self = this;
    const totalProgressCount = $( '.m-selector__progress-count' ).length;
    let offset = 0;

    if ( 'guest' === self.data.segment ) {
      offset = 1;
    }

    self.$circleSliderProgress.data( 'roundSlider' ).setValue( ( screenIndex - ( screenIndex > 1 ? offset : 0 ) ) / ( totalProgressCount - ( offset ) ) * 100 );
  },

  closePreloader( toggleSlideId = 0 ) {
    const self = this;

    $( '[data-slide-id=' + toggleSlideId + ']' ).addClass( 'slide--active' );

    setTimeout( () => {
      self.$preloader.removeClass( 'preloader--active' );
    }, 800 );

    setTimeout( () => {
      $( '[data-slide-id=' + toggleSlideId + ']' ).removeClass( 'slide--no-display' );
    }, 900 );

    setTimeout( () => {
      $( '[data-slide-id=' + toggleSlideId + ']' ).removeClass( 'slide--hidden' );
    }, 1100 );

    if ( this.isTouchDevice() === false ) {
      $( '[data-toggle="popover"]' ).popover( {
        html: true,
      } );

      self.$body.on( 'click', '.icon--close-popover', function () {
        $( '[data-toggle="popover"]' ).popover( 'hide' );
      } );
    }
  },

  closeSelector( e ) {
    if ( e ) e.preventDefault();

    this.$ajaxForm.addClass( 'ajax-mattress-form--hidden' );

    setTimeout( () => {
      $( '.slide' ).addClass( 'slide--hidden' );
    }, 500 );

    setTimeout( () => {
      $( '.slide' ).addClass( 'slide--no-display' );
    }, 700 );

    this.$body.removeClass( 'disable-y-scroll' );
    this.$mattressContainer.css( 'visibility', 'hidden' );
    this.$mattressContainer.removeClass( 'create-mattress--active' );
  },

  isTouchDevice() {
    return true === (
      'ontouchstart' in window ||
      (
        'DocumentTouch' in window &&
        window.DocumentTouch &&
        document instanceof window.DocumentTouch
      )
    );
  },

  toggleScreen( screenIndex ) {
    const activeSlide = $( '[data-slide-id=' + screenIndex + ']' );
    const otherSlides = $( '.slide' );

    otherSlides.addClass( 'slide--hidden' );
    otherSlides.removeClass( 'slide--active' );

    setTimeout( () => {
      otherSlides.addClass( 'slide--no-display' );
    }, 200 );

    setTimeout( () => {
      activeSlide.removeClass( 'slide--no-display' );
      activeSlide.addClass( 'slide--active' );
    }, 200 );

    setTimeout( () => {
      activeSlide.removeClass( 'slide--hidden' );
    }, 300 );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push( {
      event: 'mattressSelect.step',
      step: screenIndex,
    } );
  },

  updateSegment( segment ) {
    const self = this;

    if ( 'undefined' !== typeof segment ) {
      self.data.segment = segment;
    }

    self.$wrapper.attr( 'data-active-segment', self.data.segment );
    $( document.body ).trigger( 'segmentChange.mSelector' );
  },

  initRangeSlider( {
                     dataKey,
                     el,
                     descriptionEl,
                     initialRangeSetting,
                     initialStartIndex = 0,
                     segmentRangeSettings = {}
                   } ) {
    const self = this;

    noUiSlider.create( el, {
      start: initialStartIndex,
      snap: true,
      range: initialRangeSetting.range,
    } );

    el.noUiSlider.on( 'update', function ( values ) {
      const index = Math.floor( values[ 0 ] );
      const segment = self.data.segment;
      let valuesObj;

      if ( segment in segmentRangeSettings ) {
        valuesObj = Object.assign( {}, segmentRangeSettings[ segment ].values );
      } else {
        valuesObj = Object.assign( {}, initialRangeSetting.values );
      }

      const valueKey = Object.keys( valuesObj )[ index ];
      self.data[ dataKey ] = valueKey;
      descriptionEl.innerHTML = valuesObj[ valueKey ];

      if (
        segment in segmentRangeSettings &&
        'callback' in segmentRangeSettings[ segment ]
      ) {
        segmentRangeSettings[ segment ].callback( index );
      } else if ( 'callback' in initialRangeSetting ) {
        initialRangeSetting.callback( index );
      }
    } );

    $( document.body ).on( 'segmentChange.mSelector', function () {
      const segment = self.data.segment;

      if ( segment in segmentRangeSettings ) {
        el.noUiSlider.updateOptions( {
          range: segmentRangeSettings[ segment ].range,
          start: ( 'startIndex' in segmentRangeSettings[ segment ] ) ? segmentRangeSettings[ segment ].startIndex : initialStartIndex,
        }, true );
      } else {
        el.noUiSlider.updateOptions( {
          range: initialRangeSetting.range,
          start: initialStartIndex,
        }, true );
      }
    } );
  },

  loadScreens( e ) {
    if ( e ) {
      e.preventDefault();
    }

    this.$body.addClass( 'disable-y-scroll' );

    this.loadScreenSegments();
    this.loadScreenFirmness();
    this.loadScreenPose();
    this.loadScreenOtherInformation();
    this.loadComponentCircularRange();
    this.loadComponentCircularProgress();

    this.closePreloader( this.firstSlide );
    this.updateSegment();
  },

  loadScreenSegments() {
    const self = this;
    const segmentSwiper = new Swiper( '.ms-segments', {
      direction: 'horizontal',
      centeredSlides: true,
      draggable: true,
      grabCursor: false,
      slidesPerView: 1,
      initialSlide: swiperInitialValues.segment.slideIndex,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.ms-segments .swiper-button-next',
        prevEl: '.ms-segments .swiper-button-prev',
      },
      on: {
        slideChange: function ( swiper ) {
          const value = $( swiper.slides[ swiper.realIndex ] ).data( 'segment' );
          if ( ( 'undefined' !== typeof value ) && value.length ) {
            self.updateSegment( value );
          }
        }
      }
    } );

    self.$body.on( 'click', '.ms-segments .swiper-slide:not(.swiper-slide-active)', function ( e ) {
      e.preventDefault();

      segmentSwiper.slideTo( $( this ).data( 'slide-index' ) );
    } );
  },

  loadScreenFirmness() {
    const self = this;

    const firmnessSwiper = new Swiper( '.firmness-items', {
      centeredSlides: true,
      direction: 'horizontal',
      grabCursor: false,
      draggable: true,
      slidesPerView: 1,
      initialSlide: swiperInitialValues.firmness.slideIndex,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.firmness-items .swiper-button-next',
        prevEl: '.firmness-items .swiper-button-prev',
      },
      on: {
        slideChange: function ( swiper ) {
          const value = $( swiper.slides[ swiper.realIndex ] ).data( 'firmness' );
          if ( ( 'undefined' !== typeof value ) && value.length ) {
            self.data.firmness = value;
          }
        }
      }
    } );

    self.$body.on( 'click', '.firmness-items .swiper-slide:not(.swiper-slide-active)', function ( e ) {
      e.preventDefault();

      firmnessSwiper.slideTo( $( this ).data( 'slide-index' ) );
    } );

    $( document.body ).on( 'segmentChange.mSelector', function () {
      switch ( self.data.segment ) {
        case 'guest':
        case 'child':
        case 'single':
          firmnessSwiper.slideTo( 1 );
          break;
        case 'couple':
          firmnessSwiper.slideTo( 2 );
          break;
      }
    } );
  },

  loadScreenPose() {
    const self = this;
    const mattressWidth = $( '.sleep-pose__mattress-width' );

    // Pose swiper
    const poseSwiper = new Swiper( '.pose-items', {
      centeredSlides: true,
      direction: 'horizontal',
      grabCursor: false,
      draggable: true,
      loop: false,
      loopAdditionalSlides: 16,
      slidesPerView: 1,
      initialSlide: swiperInitialValues.pose.slideIndex,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.pose-items .swiper-button-next',
        prevEl: '.pose-items .swiper-button-prev',
      },
      on: {
        slideChange: function ( swiper ) {
          const value = $( swiper.slides[ swiper.realIndex ] ).data( 'pose' );
          if ( ( 'undefined' !== typeof value ) && value.length ) {
            self.data.pose = value;
          }
        },
      }
    } );

    self.$body.on( 'click', '.pose-items .swiper-slide:not(.swiper-slide-active)', function ( e ) {
      e.preventDefault();

      poseSwiper.slideTo( $( this ).data( 'slide-index' ) );
    } );

    $( document.body ).on( 'segmentChange.mSelector', function () {
      switch ( self.data.segment ) {
        case 'child':
          poseSwiper.slideTo( 0 );
          break;
        case 'couple':
          poseSwiper.slideTo( 2 );
          break;
      }
    } );

    self.initRangeSlider( {
      dataKey: 'space',
      el: document.getElementById( 'space-range-slider' ),
      descriptionEl: document.getElementById( 'space-range-value' ),
      initialRangeSetting: {
        values: {
          small: 'I don\'t need much space',
          medium: 'I like some space',
          large: 'I like a lot of space',
          extraLarge: 'I\'d like a Super King'
        },
        range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
        callback: function ( index ) {
          mattressWidth.attr( 'data-width', index );
        }
      },
      segmentRangeSettings: {
        child: {
          values: { small: 'Only for a couple of years', medium: 'A mattress that the child can grow up on' },
          range: { 'min': 0, 'max': 1 },
        },
        couple: {
          values: {
            small: 'We like to be close',
            medium: 'We like some space',
            large: 'We like a lot of space',
            extraLarge: 'We\'d like a Super King'
          },
          range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
          startIndex: 1
        },
        guest: {
          values: { na: 'Don\'t know', small: 'My guests are usually by themselves', medium: 'My guests need space' },
          range: { 'min': 0, '50%': 1, 'max': 2 },
        }
      }
    } );
  },

  loadScreenOtherInformation() {
    const self = this;

    self.initRangeSlider( {
      dataKey: 'allergy',
      el: document.getElementById( 'allergy-range-slider' ),
      descriptionEl: document.getElementById( 'allergy-range-value' ),
      initialRangeSetting: {
        values: { no: 'No allergies', sometimes: 'Yes - sometimes', significant: 'Significant allergies' },
        range: { 'min': 0, '50%': 1, 'max': 2, },
      },
      segmentRangeSettings: {
        guest: {
          values: { na: 'Don\'t know', no: 'No allergies', sometimes: 'Yes - sometimes' },
          range: { 'min': 0, '50%': 1, 'max': 2 },
        }
      }
    } );

    self.initRangeSlider( {
      dataKey: 'aches',
      initialStartIndex: 1,
      el: document.getElementById( 'aches-range-slider' ),
      descriptionEl: document.getElementById( 'aches-range-value' ),
      initialRangeSetting: {
        values: { no: 'No issue', minor: 'Minor issues', issues: 'Major issues' },
        range: { 'min': 0, '50%': 1, 'max': 2, },
      },
      segmentRangeSettings: {
        guest: {
          values: { na: 'Don\'t know', no: 'No issue', minor: 'Minor issues', issues: 'Major issues' },
          range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
          startIndex: 0,
        }
      }
    } );

    self.initRangeSlider( {
      dataKey: 'temperature',
      el: document.getElementById( 'temperature-range-slider' ),
      descriptionEl: document.getElementById( 'temperature-range-value' ),
      initialRangeSetting: {
        values: { no: 'Just right', warm: 'Occasionally too hot', hot: 'Always too hot' },
        range: { 'min': 0, '50%': 1, 'max': 2, },
      },
    } );

    self.initRangeSlider( {
      dataKey: 'budget',
      el: document.getElementById( 'values-range-slider' ),
      descriptionEl: document.getElementById( 'values-range-value' ),
      initialStartIndex: 2,
      initialRangeSetting: {
        values: {
          budget: 'On a budget',
          good: 'A reasonable price',
          better: 'Willing to spend more',
          best: 'I want the best'
        },
        range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
      },
      segmentRangeSettings: {
        child: {
          values: {
            budget: 'On a budget',
            good: 'A reasonable price',
            better: 'Willing to spend more',
            best: 'I want the best'
          },
          range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
          startIndex: 0
        },
        guest: {
          values: {
            budget: 'On a budget',
            good: 'A reasonable price',
            better: 'Willing to spend more',
            best: 'I want the best'
          },
          range: { 'min': 0, '33.33333%': 1, '66.66666%': 2, 'max': 3 },
          startIndex: 0
        }
      }
    } );

    self.initRangeSlider( {
      dataKey: 'sporting',
      initialStartIndex: 1,
      el: document.getElementById( 'sport-range-slider' ),
      descriptionEl: document.getElementById( 'sport-range-value' ),
      initialRangeSetting: {
        values: {
          no: 'Not at the moment',
          normal: 'Normal sporting activities',
          challenging: 'Challenging sporting activities',
        },
        range: { 'min': 0, '50%': 1, 'max': 2, },
      },
    } );
  },

  loadComponentCircularRange() {
    const self = this;

    const $circleSliderAge = $( '.circle-range-slider--age' );
    $circleSliderAge.roundSlider( {
      sliderType: 'min-range',
      startAngle: '90',
      handleSize: '20',
      circleShape: 'full',
      lineCap: 'square',
      radius: 100,
      width: 10,
      min: 16,
      max: 120,
      value: 24,
      svgMode: true,
      pathColor: '#546270',
      rangeColor: 'var(--e-global-color-primary)',
      borderWidth: 0,
      valueChange: function ( e ) {
        const obj = $circleSliderAge.data( 'roundSlider' );

        self.data.age = obj.getValue();
      }
    } );

    const $circleSliderAgeChild = $( '.circle-range-slider--age-child' );
    $circleSliderAgeChild.roundSlider( {
      sliderType: 'min-range',
      startAngle: '90',
      handleSize: '20',
      circleShape: 'full',
      lineCap: 'square',
      radius: 100,
      width: 10,
      min: 2,
      max: 18,
      value: 8,
      svgMode: true,
      pathColor: '#546270',
      rangeColor: 'var(--e-global-color-primary)',
      borderWidth: 0,
      valueChange: function ( e ) {
        const obj = $circleSliderAgeChild.data( 'roundSlider' );

        self.data.age = obj.getValue();
      }
    } );

    const $circleSliderWeight = $( '.circle-range-slider--weight' );
    $circleSliderWeight.roundSlider( {
      sliderType: 'min-range',
      startAngle: '90',
      handleSize: '20',
      circleShape: 'full',
      lineCap: 'square',
      radius: 100,
      value: 65,
      width: 10,
      min: 10,
      max: 150,
      svgMode: true,
      pathColor: '#546270',
      rangeColor: 'var(--e-global-color-primary)',
      borderWidth: 0,
      valueChange: function ( e ) {
        const obj = $circleSliderWeight.data( 'roundSlider' );

        self.data.weight = obj.getValue();
      }
    } );

    $( document.body ).on( 'segmentChange.mSelector', function () {
      switch ( self.data.segment ) {
        case 'child':
          self.data.age = $circleSliderAgeChild.data( 'roundSlider' ).getValue();
          break;
        default:
          self.data.age = $circleSliderAge.data( 'roundSlider' ).getValue();
      }
    } );
  },

  loadComponentCircularProgress() {
    const self = this;

    self.$circleSliderProgress.roundSlider( {
      sliderType: 'min-range',
      startAngle: '90',
      handleSize: '0',
      circleShape: 'full',
      lineCap: 'square',
      radius: 350,
      width: 4,
      min: 0,
      max: 100,
      value: 0,
      showTooltip: false,
      svgMode: true,
      pathColor: '#546270',
      rangeColor: 'var(--e-global-color-primary)',
      borderWidth: 0,
      valueChange: function ( e ) {
      }
    } );
  },
};
